import FactCheckIcon from '@mui/icons-material/FactCheck';
import SettingsIcon from '@mui/icons-material/Settings';
import BarChartIcon from '@mui/icons-material/BarChart';
import CheckIcon from '@mui/icons-material/Check';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import GridViewIcon from '@mui/icons-material/GridView';
import ContactsIcon from '@mui/icons-material/Contacts';
import CampaignsIcon from '@mui/icons-material/Campaign';
import SalesIcon from '@mui/icons-material/PointOfSale';
import SupportIcon from '@mui/icons-material/Support';
import ReportsIcon from '@mui/icons-material/BarChart';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
const sidebarItems = [
  {
      text: 'Dashboard',
      icon: <GridViewIcon />,
      requiredPermission: "auth.dashboard",
      path: '/dashboard',
      submodules: [
      //{ text: 'Dashboard', icon: <CheckIcon />, path: '/dashboard' },
      ],
  },
  {
    text: 'Validar',
    icon: <FactCheckIcon />,
    requiredPermission: "auth.validar",

    submodules: [
      { text: 'Validar Ventas',  path: '/validacion/validacion' },
    ],
  },
  {
    text: 'Uploads',
    icon: <CloudUploadIcon />,
    requiredPermission: "auth.upload",

    submodules: [
      { text: 'Carga de Base',  path: '/campaign/base' },
      { text: 'Consulta Estado Alfin',  path: '/alfin/consultaEstados' },

    ],
  },
  {
    text: 'Mantenimiento',
    icon: <ManageAccountsIcon />,
    requiredPermission: "auth.mantenimiento",

    submodules: [
        { text: 'Usuario',  path: '/users' },
        { text: 'Linea de negocio',  path: '/campaign/config' },

    ],  
  },
  {
    text: 'Canales',
    icon: <ContactsIcon />,
    requiredPermission: "auth.agente",
    submodules: [
      { text: 'Gestionar Contacto', path: '/contacts/search' ,requiredPermission: "auth.agente"},
      { text: 'Lista de Contactos', path: '/contacts/list'  ,requiredPermission: "auth.admin"},
      { text: 'Agregar Contacto', path: '/contacts/add'  ,requiredPermission: "auth.admin"},
      { text: 'Ventas Alfin', path: '/contacts/ventaAlfin'  ,requiredPermission: "auth.fichaalfin"},
    ],
  },
  {
    text: 'Campañas',
    icon: <CampaignsIcon />,
    requiredPermission: "auth.canales",

    submodules: [
      { text: 'Todas las Campañas',  path: '/campaigns/all' },
      { text: 'Nueva Campaña',  path: '/campaigns/new' },
    ],
  },
  {
    text: 'Ventas',
    icon: <SalesIcon />,
    requiredPermission: "auth.ventas",

    submodules: [
      { text: 'Oportunidades',  path: '/sales/opportunities' },
      { text: 'Cotizaciones',  path: '/sales/quotes' },
    ],
  },
  {
    text: 'Soporte',
    icon: <SupportIcon />,
    requiredPermission: "auth.mantenimiento",

    submodules: [
      { text: 'Tickets',  path: '/support/tickets' },
      { text: 'Artículos de Ayuda',  path: '/support/articles' },
    ],
  },
  {
    text: 'Reportes',
    icon: <ReportsIcon />,
    requiredPermission: "auth.mantenimiento",

    submodules: [
        { text: 'Reportes',  path: '/reportes' },
      ],  
  },
  {
    text: 'Configuración',
    icon: <SettingsIcon />,
    requiredPermission: "auth.mantenimiento",
    submodules: [
      { text: 'Mi Perfil',  path: '/settings/perfil' },
      { text: 'Roles y Permisos',  path: '/settings/roles' },
    ],
  },
];

export default sidebarItems;
